import { Typography } from "@material-ui/core";
import React from "react";

const EmptySelector = ({ displayName }) => {
	return (
		<Typography variant="h5">{`Cannot find a suitable selector for ${displayName}`}</Typography>
	);
};

export default EmptySelector;
